(function(angular, module) {var LogItem, TagLog, TagNotificationService;

LogItem = (function() {
  function LogItem() {
    this.names = [];
    this.count = 0;
  }

  LogItem.prototype.sendMessage = function(Notifications, tag, language) {
    var msg;
    if (this.count === 0) {
      return;
    }
    msg = [language, tag.name];
    if (this.count !== this.names.length || this.count > 2) {
      msg.splice(0, 0, this.count, tag.tag_for + 's');
    } else {
      msg.splice(0, 0, this.names.join(' and '));
    }
    Notifications.success(msg.join(' '));
  };

  return LogItem;

})();

TagLog = (function() {
  function TagLog(tag) {
    this.tag = tag;
    this.added = new LogItem();
    this.removed = new LogItem();
  }

  TagLog.prototype.sendMessages = function(Notifications) {
    this.added.sendMessage(Notifications, this.tag, 'added to');
    this.removed.sendMessage(Notifications, this.tag, 'removed from');
  };

  return TagLog;

})();

TagNotificationService = function($rootScope, Notifications, Debouncer) {
  'ngInject';
  var addEntityCount, addEntityName, display, getLog, messages, service;
  service = this;
  messages = {};
  addEntityCount = function(tag, action, count) {
    getLog(tag)[action].count += count;
  };
  addEntityName = function(tag, action, entityName) {
    var log;
    log = getLog(tag)[action];
    log.count += 1;
    log.names.push(entityName);
  };
  this.addResponse = function(response) {
    var action, tag;
    action = response.config.method === 'POST' ? 'added' : 'removed';
    tag = response.data.tag;
    if (response.data.entity_name != null) {
      addEntityName(tag, action, response.data.entity_name);
    } else {
      addEntityCount(tag, action, response.data.entity_count);
    }
    display.call();
  };
  getLog = function(tag) {
    if (messages[tag.id] == null) {
      messages[tag.id] = new TagLog(tag);
    }
    return messages[tag.id];
  };
  display = function() {
    var id, log;
    Notifications.clearAll();
    for (id in messages) {
      log = messages[id];
      log.sendMessages(Notifications);
    }
    messages = {};
    $rootScope.$broadcast('TagNotification.displayed');
  };
  display = new Debouncer(display, 1000);
  return this;
};

module.factory('TagNotificationService', TagNotificationService);
})(angular, angular.module("dybTags"));